import {
  Box,
  Center,
  Link,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@cardboard-ui/react';
import { Card, CardProps } from 'components/cards/Card';
import React from 'react';
import { MaybeLinkProps } from '@cardboard-ui/Link';

interface MobileMenuEntryProps {
  icon: React.ReactNode;
  title: string;
  onClick?: () => void;
  bg?: CardProps['bg'];
}

export const MobileMenuEntry = ({
  icon,
  title,
  onClick,
  bg,
  ...linkProps
}: MaybeLinkProps<MobileMenuEntryProps>) => {
  return (
    <LinkBox h="100%">
      <Card onClick={onClick} h="100%" bg={bg}>
        <Center w="100%" h="100%" p={2}>
          <Stack textAlign="center" spacing={1}>
            <Box color="blue.500" fontSize="2xl">
              {icon}
            </Box>
            {onClick ? (
              <Text>{title}</Text>
            ) : (
              <LinkOverlay as={Link} {...linkProps}>
                {title}
              </LinkOverlay>
            )}
          </Stack>
        </Center>
      </Card>
    </LinkBox>
  );
};
